import classnames from 'classnames';
import React, { Component } from 'react';
import { Row } from 'reactstrap';
import ic_password_hidden_accent from '../../../lib/components/icons/ic_password_hidden_accent.png';
import ic_password_shown_accent from '../../../lib/components/icons/ic_password_shown_accent.png';
import { InlineTooltip } from '../tooltips';
import './styles.css';

const Label = ({
    error,
    className,
    children,
    ...props
}) => {
    return (
        <label className="label" {...props}>
            {children}
        </label>
    );
};

export class TextInputPassword extends Component {
    constructor() {
        super();
        this.state = {
            isPasswordVisible: false,
            value: [],
        };
    }

    render() {
        const {
            id,
            label,
            textTooltip,
            error,
            className,
            placeholder,
            value,
            onChange,
            required
        } = this.props;

        const classes = classnames(
            // 'input-group',
            {
                'animated shake error': !!error,
            },
            className
        );

        let inline = [];

        if (textTooltip !== undefined) {
            inline =
                <InlineTooltip id={id} text={textTooltip} />
        }
        let _visibility = 'hidden'
        if (value !== undefined) {
            if (value.length > 0) {
                _visibility = 'visible'
            }
        }

        return (
            <div style={{ marginBottom: 10 }}>
                <Row >
                    <div className="col-md-12"  >
                        <div className={classes}>
                            <Label htmlFor={id} error={error}>
                                {label}{required ? "* " : <span className='text-iotera-optional'>{' (Optional) '}</span>}
                                {inline}
                            </Label>
                        </div>
                    </div>
                </Row>
                <Row>
                    <div className="col-md-12" >
                        <div className={classes}>
                            <Row className="input-mask" style={{ minWidth: '100%', marginLeft: 0, marginRight: 10 }}>
                                <div className="col-sm-11" style={{ marginLeft: 0, marginRight: 0, padding: 0 }}  >
                                    {this.state.isPasswordVisible ?
                                        <input
                                            className="input-masks"
                                            type='text'
                                            placeholder={placeholder}
                                            id={id}
                                            value={value}
                                            onChange={onChange}
                                            style={{ border: '0px solid #ffffff00', padding: 0, margin: 0 }}
                                        /> :
                                        <input
                                            className="input-masks"
                                            type='password'
                                            placeholder={placeholder}
                                            id={id}
                                            value={value}
                                            onChange={onChange}
                                            style={{ border: '0px solid #ffffff00', padding: 0, margin: 0 }}
                                        />}
                                </div>
                                <div className="col-sm-1" style={{ padding: '0 5px' }}>

                                    <div
                                        style={{
                                            marginLeft: 0,
                                            minWidth: '100%',
                                            borderRadius: 3,
                                            color: '#FFFFFF00',
                                            textAlign: 'center',
                                            visibility: _visibility
                                        }}
                                    >
                                        {this.state.isPasswordVisible ?
                                            <img src={ic_password_hidden_accent} alt="Sembunyikan" className="icon-button-iotera" style={{ height: 20, width: 20, cursor: 'pointer' }} onClick={() => this.setState({ isPasswordVisible: !this.state.isPasswordVisible })} /> :
                                            <img src={ic_password_shown_accent} alt="Lihat" className="icon-button-iotera" style={{ height: 20, width: 20, cursor: 'pointer' }} onClick={() => this.setState({ isPasswordVisible: !this.state.isPasswordVisible })} />}
                                    </div>
                                </div>
                            </Row>
                        </div>
                    </div>
                </Row>
                <Row>
                    <div className="col-md-12"  >
                        <div className={classes}>
                            <InputFeedback error={error} />
                        </div>
                    </div>
                </Row>
            </div>
        );
    }
}

const InputFeedback = ({ error }) =>
    error ?
        <div className="input-feedback" style={{ fontStyle: 'italic' }}>{error}</div> : null